import { render } from "./AuthorInfoComponent.vue?vue&type=template&id=493fca4d&scoped=true"
const script = {}

import "./AuthorInfoComponent.vue?vue&type=style&index=0&id=493fca4d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-493fca4d"]])

export default __exports__